import { render, staticRenderFns } from "./airports-suche-multiselect.vue?vue&type=template&id=5b5ff706"
import script from "./airports-suche-multiselect.vue?vue&type=script&lang=js"
export * from "./airports-suche-multiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports